import Head from 'next/head';
import { Box, Container, Tab, Card, Typography, Button, Modal, TextField, Grid } from '@mui/material'; 
import { ItemListResults } from '../list/list-results';
import { DashboardLayout } from '../dashboard-layout';

import {useState, useEffect} from 'react';
import { TabContext, TabList, TabPanel} from '@mui/lab';

import {emptyStrIfNull, timeSlotString, shrink, decimalToHourString} from '../Utils';

import { debugL } from '../../custom';

import {useAuth} from "../../contexts/AuthContext"

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import OrderCard from './OrderCard';
import { Timestamp } from 'firebase/firestore';
import { canBeSetCanceled, canBeSetCanceledInGroup, canBeSetReady, canBeSetReadyInGroup, canBeSetWaiting, canBeSetWaitingInGroup, isShopifyB2C } from './OrderUtils';
const db = app.firestore();

const dayLetters = ["l", "m", "M", "j", "v", "s", "d"];

function sortingTimeBySmallestFirst(a,b) {
  if (!b.timeSlot && a.timeSlot) {
    return 1;
  }
  else if (!a.timeSlot && b.timeSlot) {
    return -1;
  }
  else if (!a.timeSlot && !b.timeSlot) {
    return a.creationDate - b.creationDate;
  }
  else if (a.timeSlot && b.timeSlot) {
    return a.timeSlot - b.timeSlot;
  }
}

function makeCode(length) {
    var result           = '';
    // var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var characters       = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

function nextRecurentOrder(order){
  console.log("nextRecurentOrder started");
  let date = order.timeSlot.toDate();
  if(order.frequency === "monthly") {            
      date.setMonth(date.getMonth()+1);
  } else if (order.frequency === "weekly") {
      date.setDate(date.getDate()+7);
  } else if (order.frequency === "biweekly") {
      date.setDate(date.getDate()+14);
  } else { // "daily"

      const recDailyDays = order.recDailyDays ?? "1111111" ;
      const day = (date.getDay() - 1 + 7) % 7;

      let dayIncr = 1;
      let nextDay = recDailyDays.indexOf("1", day+1);
      if(nextDay != -1) {
          dayIncr = nextDay - day;
      } else {
          nextDay = recDailyDays.indexOf("1");
          if(nextDay != -1) {
              dayIncr = nextDay - day + 7
          }
      } 
          
      date.setDate(date.getDate()+dayIncr);
  }
  const newOrder = { ...order };
  newOrder.timeSlot = Timestamp.fromDate(date);
  if(order.recDefReady) {
      newOrder.orderStatus = "paid";
  } else {
      newOrder.orderStatus = "wait_min_ts";
  }
  newOrder.code = makeCode(4);
  newOrder.creationDate = Timestamp.fromDate(new Date());        

  // console.log("Next recurrent order :");
  // console.log(newOrder);

  return newOrder;
}

async function getOrders(retailerId, isMobile) {
  // console.log("Get orders started");
  try {

    const today = new Date();
    const sixMonthAgo = new Date( today.getTime() - 180 * 24 * 60 * 60 * 1000 );

    let cartQueryDocs = ( 
      await db.collection("carts")
        .where("orderStatus" , "in" , allOrderStatuses)
        .where("retailerId", "==", retailerId)
        .where("creationDate" , ">" ,  sixMonthAgo)
        .orderBy("creationDate", "desc")  // just for optimization. not really needed
        .get()
    ).docs;

    // TODO this fix doesn't work because some carts have timeSlot undefined (can't be tested)
    // cartQueryDocs = cartQueryDocs.concat(
    //   ( 
    //     await db.collection("carts")
    //       .where("orderStatus" , "in" , allOrderStatuses)
    //       .where("retailerId", "==", retailerId)
    //       .where("timeSlot", "==", "")
    //       .limit(100).get()
    //   ).docs
    // )

    // a merchant can only be in one retailer.
    const orders = cartQueryDocs
      .map(doc => {
        const r = doc.data();
        const duration = parseInt(r.timeSlotDuration ? r.timeSlotDuration : "1");  
        
        let startTime = new Date();
        if(r.startHour) {
          const datePart = r.timeSlot.toDate();                
          startTime = new Date(datePart);
          startTime.setHours(r.startHour, r.startMinute, 0, 0); // Sets hour, minute, seconds, ms
        }
        let startTimeStr = startTime.toLocaleString('fr-FR');

        let customer = "";        
        if(r.customerAddress) {
          if(r.customerAddress.company) {
            customer = r.customerAddress.company;
          } else {
            customer = 
              emptyStrIfNull(r.customerAddress.firstName) + 
              emptyStrIfNull(r.customerAddress.firstname) +
              " " + 
              emptyStrIfNull(r.customerAddress.lastName) + 
              emptyStrIfNull(r.customerAddress.lastname)
          }
        }
        let expeditor = "";
        if(r.pickupAddress) {
          if(r.pickupAddress.company) {
            expeditor = r.pickupAddress.company;
          } else {
            expeditor = 
              emptyStrIfNull(r.pickupAddress.firstName) + 
              emptyStrIfNull(r.pickupAddress.firstname) +
              " " + 
              emptyStrIfNull(r.pickupAddress.lastName) + 
              emptyStrIfNull(r.pickupAddress.lastname)
          }
        } else {
          expeditor = "(en boutique)";
        }
        // if(r.deliveredTo && r.deliveredTo !== "") {
        //   customer = "(OK) " + customer;
        // }
        const optionsArr = [];
        if(r.containerReturn == 1) {
          optionsArr.push("R");          
        }    
        if(["0-4"].includes(r.temperatureRange)) {
          optionsArr.push("F");
        }
        if(r.voluminosity == 1) {
          optionsArr.push("V");          
        }         
        let timeSlotFullStr = emptyStrIfNull(r.timeSlotString) + 
              (r.timeSlot ? timeSlotString(r.timeSlot.toDate(), duration) : "");

        let recExtraStr = "";

        if(r.frequency == "daily") {
          const days = r.recDailyDays
            .split("")
            .map((char, index) => (char === "1" ? dayLetters[index] : ""))
            .join("");
          recExtraStr = " - Q[" + days + "]";
        } else if(r.frequency == "weekly") {
          recExtraStr = " - H";
        } else if(r.frequency == "biweekly") {
          recExtraStr = " - B";
        } else if(r.frequency == "montly") {
          recExtraStr = " - M";
        }

        timeSlotFullStr += recExtraStr;
        startTimeStr += recExtraStr;

        return {
          startTimeStr: startTimeStr,
          nActionsPoints: r.pointEtas?.length,
          tourDuration: (r.isTourMode && r.tourDuration) ? decimalToHourString(r.tourDuration) : "",
          data: r,
          id: doc.id,
          name: r.name ? shrink(r.name, isMobile ? 10 : 40) : emptyStrIfNull(r.retailerOrderId),
          destAddress : r.customerAddress?.address1, 
          options: optionsArr.join("-"),
          temperatureRange : (["0-4"].includes(r.temperatureRange)) ? r.temperatureRange + "°" : "",
          customer: shrink(customer, 20),
          expeditor: shrink(expeditor, 20),
          // phoneNumber: r.phoneNumber ? r.phoneNumber : "",
          timeSlotFullString : timeSlotFullStr,          
          timeSlot : r.timeSlot,          
          pickupTimeString : r.pickupTime ? decimalToHourString(r.pickupTime) : "",
          loberzStatus : r.orderStatus,
          loberzCode : r.code,
          creationDate : r.creationDate.toDate(),
          deliveryNotePath : r.deliveryNotePath,
          deliveredTo: r.deliveredTo,
          weight: "" + (r.weight??2) + " kg",
          invoiceUnits : "" + r.invoiceUnits + " U",
          instructions: r.customerAddress?.instructions,
          retailerOrderId : r.retailerOrderId,
          retailerId : r.retailerId
        }        
      }).sort(sortingTimeBySmallestFirst);

    return orders ? orders : [];

  } catch (e) {
    console.log("ERROR in get orders");
    console.log(e.message);
    return [];
  }
}

const ordersPartition = {
  ongoing: ["locked", "imminent", "picked",],
  pendingOrScheduled: ["paid", "wait_ts", "wait_min_ts"],
  history: ["delivered", "canceled", "err_dest", "canceled_late"],
}

const allOrderStatuses = [
  "locked", "picked", "imminent",
  "paid", "wait_ts", "wait_min_ts", 
  "delivered", "canceled", "err_dest", "canceled_late"
];

// ----------------------------------------

const allAttributes = {
  "Référence": "name",
  "Poids" : "weight",
  "Unités" : "invoiceUnits",
  "Opt.":"options",
  "Expéditeur": "expeditor",
  "Destinataire": "customer",
  "Créneau horaire": "timeSlotFullString",
  "Prête à": "pickupTimeString",
  "BL": "deliveryNotePath",
  "Code": "loberzCode",
  "Statut": "loberzStatus"
}

const minimalAttributes = {
  "Référence": "name",
  "Expéditeur": "expeditor",
  "Destinataire": "customer",
  "Créneau horaire": "timeSlotFullString",
  "Code": "loberzCode",
  "Statut": "loberzStatus"
}

const tourAttributes = {
  "Référence": "name",
  "Créneau horaire": "startTimeStr",
  "Durée" : "tourDuration",
  "N. Points" : "nActionsPoints",
  "Code": "loberzCode",
  "Statut": "loberzStatus"
}

// const attributes = {
//   "Référence": "name",
//   "Poids" : "weight",
//   // "Instructionsx":  "instructions",
//   "Expéditeur": "expeditor",
//   "Destinataire": "customer",
//   "Créneau horaire": "timeSlotString",
//   "Code": "loberzCode",
//   "Statut": "loberzStatus"
// }

// const attributesWithUnits = {
//   "Référence": "name",
//   "Unités" : "invoiceUnits",
//   "Expéditeur": "expeditor",
//   "Destinataire": "customer",
//   "Créneau horaire": "timeSlotString",
//   "Code": "loberzCode",
//   "Statut": "loberzStatus"
// }

// const attributesWithBL = {
//   "Référence": "name",
//   "Poids" : "weight",
//   "Expéditeur": "expeditor",
//   "Destinataire": "customer",
//   "Créneau horaire": "timeSlotString",
//   "BL": "deliveryNotePath",
//   "Code": "loberzCode",
//   "Statut": "loberzStatus"
// }

// const attributesWithBLAndTemp = {
//   "Référence": "name",
//   "Temp." : "temperatureRange",
//   "Poids" : "weight",
//   "Expéditeur": "expeditor",
//   "Destinataire": "customer",
//   "Créneau horaire": "timeSlotString",
//   "BL": "deliveryNotePath",
//   "Code": "loberzCode",
//   "Statut": "loberzStatus"
// }

// const attributesWithName = {
//   "Référence": "name",
//   "Poids" : "weight",
//   "Expéditeur": "expeditor",
//   "Destinataire": "customer",
//   "Créneau horaire": "timeSlotString",
//   "Livré à": "deliveredTo",
//   "Code": "loberzCode",
//   "Statut": "loberzStatus"
// }

// A more refined style for the modal, matching the app's aesthetic
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'clamp(300px, 90vw, 500px)', // Responsive width
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 1, // Softer corners
};

function RecurrenceModal({ open, onClose, onConfirm, setLastRefreshDate }) {
  const [numOccurrences, setNumOccurrences] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirmClick = async () => {
    setIsSubmitting(true);
    await onConfirm(numOccurrences);
    setLastRefreshDate(new Date());
    setIsSubmitting(false);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="recurrence-modal-title"
    >
      <Box sx={modalStyle}>
        <Container maxWidth="md" sx={{ py: 3 }}>
          <Typography id="recurrence-modal-title" variant="h5" sx={{ mb: 3 }}>
            Pré-générer les occurences suivantes
          </Typography>
          <Grid container spacing={3}>
            {/* <Grid item xs={12}>
              <Typography color="textPrimary" variant="h6">
                Paramètres
              </Typography>
            </Grid> */}
            <Grid item xs={12}>
              <TextField
                autoFocus
                value={numOccurrences}
                onChange={(e) => setNumOccurrences(parseInt(e.target.value, 10) || 1)}
                label="Nombre d'occurrences à pré-générer"
                type="number"
                variant="outlined" // Use outlined style to match OrderCard
                fullWidth
                InputProps={{ inputProps: { min: 1, max: 30 } }} // Set reasonable limits
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ pt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="outlined" onClick={onClose} sx={{ mr: 2 }}>
                  Annuler
                </Button>
                <Button variant="contained" onClick={handleConfirmClick} disabled={isSubmitting}>
                  Confirmer
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Modal>
  );
}

function OrdersFullPanel({lastRefreshDate, setLastRefreshDate, initialTab, setInitialTab, toggleDrawer, handleOpenRecurrenceModal, isMobile}) {  

  const { retailerId, currentUser, retailerData } = useAuth();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true); // todo handle loading.
  const [historyAttrs, setHistoryAttrs] = useState(minimalAttributes);
  const [nonHistoryAttrs, setNonHistoryAttrs] = useState(minimalAttributes);

  const mobileAttributes = {
    "Référence": "name",
    "Statut": "loberzStatus"
  }

  // const [value, setValue] = useState(initialTab);

  const loadOrders = async () => {
    // console.log("loadOrders called");
    try {
      const newOrders = await getOrders(retailerId, isMobile);
      setOrders(newOrders);
      setLoading(false);
      debugL > 1 && console.log(newOrders.length);
    } catch(e) {
      console.log("error while loading orders");
      console.log(e.message);
      setOrders([]);
      setLoading(false);
    }
  }

  useEffect(() => {
    debugL > 1 && console.log("LOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO")
    loadOrders();
  }, [retailerId, lastRefreshDate]);

  useEffect(() => {
    const nonHistoryAttrs = Object.assign({}, allAttributes);
    const historyAttrs = Object.assign({}, allAttributes);

    if(retailerData.hasInvoiceUnits && retailerData.invoiceUnitsImplyWeight) {
      delete nonHistoryAttrs["Poids"]
      delete historyAttrs["Poids"]      
    } 
    if(!retailerData.hasInvoiceUnits) {
      delete nonHistoryAttrs["Unités"]
      delete historyAttrs["Unités"]
    }
    if(!["dose.paris"].includes(retailerId)) {
      delete nonHistoryAttrs["BL"];
      delete historyAttrs["BL"];
    }
    if(!retailerData.hasTemperatureRange && !retailerData.hasVoluminosity && !retailerData.hasContainerReturn) {
      delete nonHistoryAttrs["Opt."];
      delete historyAttrs["Opt."];
    }
    console.log(retailerData);
    if(retailerData.pricingMode && retailerData.pricingMode.includes("2024c")) {
      setNonHistoryAttrs(tourAttributes);
      setHistoryAttrs(tourAttributes);
    } else {
      setNonHistoryAttrs(nonHistoryAttrs);
      setHistoryAttrs(historyAttrs);
    }

    // if([
    //   "dose.paris",      
    // ].includes(retailerId)) {
    //   setNonHistoryAttrs(attributesWithBLAndTemp);
    //   setHistoryAttrs(attributesWithBLAndTemp);      
    // } else if([
    //   "cafes-lanni.com",
    //   "cafeblondie.com",
    //   "cafecaron.com"
    // ].includes(retailerId)) {
    //   setNonHistoryAttrs(attributes);
    //   setHistoryAttrs(attributesWithBL);      
    // } else if([
    //   "cafesbelleville.com",
    //   "loutsa.fr",
    // ].includes(retailerId)) {
    //   setNonHistoryAttrs(attributes);
    //   setHistoryAttrs(attributesWithName);
    // } else if([
    //   "Popotes_Capucines",
    //   "jour.fr",
    //   "Norma_The_Bakery",
    //   "thebeansonfire.com",
    //   "thebeansonfire.com3",
    //   "thebeansonfire.com4",      
    // ].includes(retailerId)) {
    //   setNonHistoryAttrs(attributesWithUnits);
    //   setHistoryAttrs(attributesWithUnits);
    // } else {
    //   setNonHistoryAttrs(attributes);
    //   setHistoryAttrs(attributes);
    // }

  }, [retailerId]);

  const handleChange = (event, newValue) => {
    setInitialTab(newValue);
  };

  return (
    <Card>
      {/* <Typography>{lastRefreshDate.toString()}</Typography> */}
      <Box sx={{ width: '100%', typography: 'body1' }}>        
        <TabContext value={initialTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" centered={isMobile}>
              <Tab label="à venir" value="1" />
              <Tab label="en cours" value="2" />
              <Tab label="finalisées" value="3" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0}}>                       
            <OrdersGroupTable
              emptyTitle="Aucune livraison Loberz à venir."
              ordersGroup="pendingOrScheduled"
              orders={orders}
              selectable={true}
              attrs={isMobile ? mobileAttributes : nonHistoryAttrs}
              setLastRefreshDate={setLastRefreshDate}
              toggleDrawer={toggleDrawer}
              handleOpenRecurrenceModal={handleOpenRecurrenceModal}
              isMobile={isMobile}
            />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0}}>
            <OrdersGroupTable
              emptyTitle="Aucune livraison Loberz en cours."
              ordersGroup="ongoing"
              orders={orders}
              // loading={this.state.loading}
              // loadOrders={this.loadOrders}
              // handleEdit={this.handleEdit}
              // handleRefresh={this.handleRefresh}
              selectable={false}
              fullSupport={currentUser.uid === "ntog5my06ZhXQwVNT9eO7GlnWpn2"}
              attrs={isMobile ? mobileAttributes : nonHistoryAttrs}
              toggleDrawer={toggleDrawer}
              handleOpenRecurrenceModal={handleOpenRecurrenceModal}
              isMobile={isMobile}
              /> 
          </TabPanel>
          <TabPanel value="3" sx={{ p: 0}}>
            <OrdersGroupTable
              emptyTitle="Aucune livraison Loberz finalisée, pour l'instant."
              ordersGroup="history"
              orders={orders}
              selectable={false}
              fullSupport={currentUser.uid === "ntog5my06ZhXQwVNT9eO7GlnWpn2"}
              attrs={isMobile ? mobileAttributes : historyAttrs}
              toggleDrawer={toggleDrawer}
              handleOpenRecurrenceModal={handleOpenRecurrenceModal}
              isMobile={isMobile}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </Card>
  );
}

function OrdersGroupTable({emptyTitle, ordersGroup, selectable, fullSupport, attrs, setLastRefreshDate, toggleDrawer, handleOpenRecurrenceModal, isMobile, ...rest}) {

  const { currentUser } = useAuth();
  const allOrders = rest.orders;
  let orders = allOrders
    .filter((order) => ordersPartition[ordersGroup].includes(order.loberzStatus));
  if(ordersGroup == "history") {
    orders.reverse();
  }
  const ordersById = {};
  for(let order of orders) {
    ordersById[order.id] = order;
  }

  const history = useHistory();
  const bulkActions = [
    {
      title: "Supprimer",
      iconName: "eva:trash-2-outline",
      handler: async (ids) => {
        console.log("Supprimer"); 
        console.log(ids);
        for(let id of ids) {
          if(canBeSetCanceled(ordersById[id].data)) {
            await db.collection("carts").doc(id).update({orderStatus: "canceled", updatedBy : currentUser.email });
          }
        }  
        setLastRefreshDate(new Date());
      },
      isVisible: (ids) => {
        for(let id of ids) {
          if(!canBeSetCanceledInGroup(ordersById[id].data)) {
            return false
          }
        }
        return true;
      }
    },
    {
      title: "Marquer En attente",
      iconName: "eva:alert-circle-outline",
      handler: async (ids) => {
        console.log("Marquer en attente"); 
        console.log(ids);
        for(let id of ids) {
          // TODO this line is not needed since lists are separated. ordersById hence also not needed.
          if(canBeSetWaiting(ordersById[id].data)) {
            await db.collection("carts").doc(id).update({orderStatus: "wait_min_ts", updatedBy : currentUser.email});
          }
        }
        setLastRefreshDate(new Date());
      },
      isVisible: (ids) => {
        for(let id of ids) {
          if(!canBeSetWaitingInGroup(ordersById[id].data)) {
            return false
          }
        } 
        return true;
      }
    },
    {
      title: "Marquer Prête",
      iconName: "eva:checkmark-circle-outline",
      handler: async (ids) => {
        console.log("Marquer prêtes"); 
        console.log(ids);
        for(let id of ids) {
          // TODO this line is not needed since lists are separated. ordersById hence also not needed.
          if(canBeSetReady(ordersById[id].data)) {
            if(ordersById[id].data.timeSlot) {
              await db.collection("carts").doc(id).update({orderStatus: "paid", updatedBy : currentUser.email});
            } else if (isShopifyB2C(ordersById[id].data)) {
              await db.collection("carts").doc(id).update({orderStatus: "wait_ts", timeSlot: null, notifToSend: "ready", updatedBy : currentUser.email});
            }
          }
        }
        setLastRefreshDate(new Date());
      },
      isVisible: (ids) => {
        for(let id of ids) {
          if(!canBeSetReadyInGroup(ordersById[id].data)) {
            return false
          }
        } 
        return true;
      }
    }
  ];

  const itemActions = [
    {
      title: "Dupliquer",
      iconName: "eva:copy-outline",
      // handler: (id) => history.push("/orders/add/"+id)
      handler: (id) => toggleDrawer(true, "Ajouter une nouvelle livraison", id, false)()
    },
  
  ];

  if(ordersGroup === "pendingOrScheduled" || fullSupport ) {
    itemActions.splice(0, 0, 
      {
        title: "Modifier",
        iconName: "eva:edit-outline",
        // handler: (id) => history.push("/orders/edit/"+id)
        handler: (id) => toggleDrawer(true, "Modifier les détails de la livraison", id, true)()
      },      
    );
  }
  
  if(ordersGroup === "pendingOrScheduled" || fullSupport ) {
    itemActions.splice(2, 0,
      {
        title: "Pré-générer",
        iconName: "eva:rewind-right-outline",
        handler: (id) => handleOpenRecurrenceModal(id),
        isVisible: (orderData) => ['daily', 'weekly', 'biweekly', 'montly'].includes(orderData.frequency)
      },
      {
        title: "Supprimer",
        iconName: "eva:trash-2-outline",
        handler: async (id) => {
          console.log("Supprimer"); 
          console.log(id);
          await db.collection("carts").doc(id).update({orderStatus: "canceled", updatedBy : currentUser.email });
          setLastRefreshDate(new Date());
        },
        isVisible: (orderData) => canBeSetCanceled(orderData) 
      },
      {
        title: "Marquer En attente",
        iconName: "eva:alert-circle-outline",
        handler: async (id) => {
          console.log("Marquer en attente"); 
          console.log(id);
          await db.collection("carts").doc(id).update({orderStatus: "wait_min_ts", updatedBy : currentUser.email});
          setLastRefreshDate(new Date());
        },
        isVisible: (orderData) => canBeSetWaiting(orderData)
      },
      {
        title: "Marquer Prête",
        iconName: "eva:checkmark-circle-outline",
        handler: async (id) => {
          console.log("Marquer prêtes"); 
          console.log(id);
          if(ordersById[id].data.timeSlot) {
            await db.collection("carts").doc(id).update({orderStatus: "paid", updatedBy : currentUser.email});
          } else if (isShopifyB2C(ordersById[id].data)) {
            await db.collection("carts").doc(id).update({orderStatus: "wait_ts", updatedBy : currentUser.email});
          }
          setLastRefreshDate(new Date());          
        },
        isVisible : (orderData) => canBeSetReady(orderData)
      },  
    );
  }

  if(!isMobile) {
    itemActions.splice(0, 0, {
      title: "Afficher",
      iconName: "eva:file-text-outline",
      handler: (id) => history.push("/orders/view/"+id)
    });
  }

  return (
    <ItemListResults
      items={orders}
      attributes={attrs}
      bulkActions={bulkActions}
      itemActions={itemActions}
      filterFields={["name", "customer", "destAddress"]} 
      selectable={selectable}
    />
  );
}

const OrderListTop = ({setLastRefreshDate, toggleDrawer, isMobile, ...rest}) => {

  const history = useHistory()

  return (
    <Box {...rest}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: (isMobile ? 'center' : 'space-between'),
          flexWrap: 'wrap',
          m: -1
        }}
      >
        {
          isMobile ? 
          null :
          <Typography sx={{ m: 1 }} variant="h4" flexGrow={1}>
            Livraisons
          </Typography>
        }
        <Box sx={{ m: 1 }}>
          <Button color="primary" variant="outlined" onClick={() => setLastRefreshDate(new Date())}>
            Rafraichir
          </Button>
        </Box>
        <Box sx={{ m: 1 }}>
          {/* <Button color="primary" variant="contained" onClick={() => history.push("/orders/add")}> */}
          <Button color="primary" variant="contained" onClick={toggleDrawer(true, "Ajouter une nouvelle livraison")}>
            Ajouter
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const Orders = ({initialTab, setInitialTab}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [lastRefreshDate, setLastRefreshDate] = useState(new Date());
  
  const { currentUser } = useAuth();
  
  const [drawerState, setDrawerState] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");

  const [orderId, setOrderId] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false); // better name : isEdit

  const [recurrenceModalOpen, setRecurrenceModalOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const handleOpenRecurrenceModal = (orderId) => {
    setSelectedOrderId(orderId);
    setRecurrenceModalOpen(true);
  };

  const handleCloseRecurrenceModal = () => {
    setRecurrenceModalOpen(false);
    setSelectedOrderId(null);
  };

  const handleConfirmRecurrence = async (numOccurrences) => {
    console.log(`User requested ${numOccurrences} occurrences for order: ${selectedOrderId}`);
    const selectedOrderDoc = await db.collection('carts').doc(selectedOrderId).get();
    let order = selectedOrderDoc.data(); // comes before update to keep frequency unchanged in order
    await db.collection('carts').doc(selectedOrderId).update({frequency: "unique"}); 
    for (let count = 0; count < numOccurrences; count++) {
      const newOrder = nextRecurentOrder(order);
      if(count!=0) {
        order.frequency = "unique";
        await db.collection('carts').add(order);
      }
      order = newOrder;
    }
    await db.collection('carts').add(order);
    console.log("handleConfirmRecurrence finished");
  };

  const toggleDrawer = (open, title, orderId, isUpdate) => (event) => {
    // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
    //   return;
    // }

    debugL > 0 && console.log("toggleDrawer called with : "+open+" "+title+" "+orderId);

    if(open) {
      setOrderId(orderId);
      setIsUpdate(isUpdate);
    } else {
      setOrderId(null);
      setIsUpdate(false);
    }

    if(open && title) {
      setDrawerTitle(title);
    }

    setDrawerState(open);
  };
  
  return (  
    <>
      <Head>
        <title>
          Livraisons
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container 
          maxWidth={false}
        >
          <OrderListTop setLastRefreshDate={setLastRefreshDate} toggleDrawer={toggleDrawer} isMobile={isMobile} />
          <Box sx={{ mt: 3 }}>
            <OrdersFullPanel 
              initialTab={initialTab} 
              setInitialTab={setInitialTab}
              lastRefreshDate={lastRefreshDate}
              setLastRefreshDate={setLastRefreshDate}
              toggleDrawer={toggleDrawer}
              handleOpenRecurrenceModal={handleOpenRecurrenceModal}
              isMobile={isMobile}/>
          </Box>
          <OrderCard
            orderId={orderId} 
            isUpdate={isUpdate} 
            setLastRefreshDate={setLastRefreshDate}
            fullSupport={currentUser.uid === "ntog5my06ZhXQwVNT9eO7GlnWpn2"} 
            drawerTitle={drawerTitle} 
            drawerState={drawerState} 
            toggleDrawer={toggleDrawer}
            isMobile={isMobile}/>
        </Container>
        <RecurrenceModal
          open={recurrenceModalOpen}
          onClose={handleCloseRecurrenceModal}
          onConfirm={handleConfirmRecurrence}
          setLastRefreshDate={setLastRefreshDate}
        />       
      </Box>
    </>
  );
}

Orders.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default Orders;
